<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="signup-page-contaier pt-md-4 py-2 px-md-5 px-3">
    <div class="row no-gutters">
      <div class="offset-xl-2 col-xl-8 offset-lg-1 col-lg-10 col-12">
        <div class="card border-0">
          <div class="pwd-recovery-page-card d-flex flex-sm-row flex-column py-2 pb-md-4 card-body">
            <div class="pwd-recovery-poster-section col-sm-6 col-12 oder-sm-0 order-1">
                <div class="d-flex justify-content-center align-items-center h-100">
                  <img src="assets/img/password-recovery.png" alt="login" srcset="" class="img-fluid">
                </div> 
            </div>
            <div class="pwd-recovery-form-section col-sm-6 col-12 order-sm-1 order-0">
                <div class="form-header">
                  <div class="company-logo pt-2 px-2">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                      <img src="assets/img/logo-4.png" alt="logo" srcset="" class="img-fluid w-70px mx-1">
                      <h1 class="m-0 title">Smart<span class="dine">Dine</span></h1>
                    </div>
                    <div class="text-center pt-2">
                      <div class="form-title mb-2">Password Recovery</div>
                    </div>
                  </div>

                  <form class="form" [formGroup]="forgotPasswordform" (ngSubmit)="onStep1FormSubmit()" *ngIf="stage === 1">
                    <p class="text-center form-subtitle">Please enter your Mobile or Email to continue.</p>
                    <ion-list class="px-sm-4 px-2">
                      <ion-item lines="none" class="error" *ngIf="errorMessage">
                        <ion-label class="ion-text-center error-message bg-light" [innerText]="errorMessage"></ion-label>
                      </ion-item>
                    
                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" [name]="iconName"></ion-icon>
                        <ion-select formControlName="countryCode" class="country-code-input mt-n-12px" [hidden]="isCountryCodeHidden()">
                          <ion-select-option value="+91">+91</ion-select-option>
                          <ion-select-option value="+1">+1</ion-select-option>
                        </ion-select>
                        <ion-input class="mt-n-12px mx-1" placeholder="Mobile Number or Email" autocomplete="off" type="text" formControlName="username"></ion-input>
                      </ion-item>

                    </ion-list>
                    <div class="px-sm-4 px-2">
                      <ion-button class="mb-2 bg-color-1283f1 border-radius-20px" expand="block" share="round" type="submit">
                        Next
                      </ion-button>
                      <div class="mb-2 ion-text-center divider"><span class="py-2 px-3 text-white">OR</span></div>
                      <ion-button class="mb-2 border-radius-20px" expand="block" share="round" color="secondary" routerLink="/login" fill="outline">
                        Log in
                      </ion-button>
                    </div>
                  </form>

                  <form class="form" [formGroup]="passwordResetform" (ngSubmit)="onStep2FormSubmit()" *ngIf="stage === 2">
                    <p class="text-center form-subtitle">Please enter verification code.</p>
                    <ion-list class="px-sm-4 px-2">
                      <ion-item lines="none" class="error mb-1" *ngIf="errorMessage">
                        <ion-label class="ion-text-center error-message bg-light pb-2" [innerText]="errorMessage"></ion-label>
                      </ion-item>
                      <ion-item lines="none" class="otp-success-message mb-1" *ngIf="otpResponseMessage">
                        <ion-label class="ion-text-center" [innerText]="otpResponseMessage"></ion-label>
                      </ion-item>
                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" name="checkmark-done-outline"></ion-icon>
                        <ion-input class="mt-n-12px mx-1" placeholder="Enter verification code" autocomplete="off" type="text" formControlName="verificationCode"></ion-input>
                      </ion-item>

                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" [name]="hidePassword?'lock-closed-outline':'lock-open-outline'"></ion-icon>
                        <ion-input class="mt-n-12px mx-1" placeholder="Enter password" autocomplete="off" [type]="hidePassword?'password':'text'" (ngModelChange)="onPasswordFieldFocus()" formControlName="password"></ion-input>
                        <ion-button clear fill="clear" slot="end" class="pwd-visibility-button mt-n-12px" (click)="togglePasswordVisibility()" [title]="hidePassword?'Show':'Hide'">
                          <ion-icon class="form-input-icon" [name]="hidePassword?'eye-outline':'eye-off-outline'" [title]="hidePassword?'Show':'Hide'"></ion-icon>
                        </ion-button>
                      </ion-item>

                      <ion-item lines="full" class="form-inputs mb-2">
                        <ion-icon class="me-1 form-input-icon mt-n-3px" slot="start" [name]="hideCnfPassword?'lock-closed':'lock-open'"></ion-icon>
                        <ion-input class="mt-n-12px mx-1" placeholder="Enter confirm password" autocomplete="off" [type]="hideCnfPassword?'password':'text'" formControlName="confirmPassword"></ion-input>
                        <ion-button clear fill="clear" slot="end" class="pwd-visibility-button mt-n-12px" (click)="toggleConfirmPassword()" [title]="hideCnfPassword?'Show':'Hide'">
                          <ion-icon class="form-input-icon" [name]="hideCnfPassword?'eye-outline':'eye-off-outline'" [title]="hideCnfPassword?'Show':'Hide'"></ion-icon>
                        </ion-button>
                      </ion-item>
                      <div *ngFor="let criterion of passwordCriteria" class="d-flex flex-column px-2 py-2">
                        <ion-label class="ion-text-start password-hint" [ngClass]="{'valid': validateCriterion(passwordResetform?.get('password').value, criterion.criterion) && isPasswordTouched, 'invalid': !validateCriterion(passwordResetform?.get('password').value, criterion.criterion) && isPasswordTouched, 'info': !isPasswordTouched }">
                          <ion-icon [name]="criterion.icon" [color]="criterion.color"></ion-icon>
                          {{ criterion.criterion }}
                        </ion-label>
                      </div>

                    </ion-list>
                    <div class="px-sm-4 px-2">
                      <ion-button class="mb-2 bg-color-1283f1 border-radius-20px" expand="block" share="round" type="submit">
                        Verify & Update
                      </ion-button>
                      <div class="mb-2 ion-text-center divider"><span class="py-2 px-3 text-white">OR</span></div>
                      <ion-button class="mb-2 border-radius-20px" expand="block" share="round" color="secondary" routerLink="/login" fill="outline">
                        Log in
                      </ion-button>
                    </div>
                  </form>

                  <div class="px-sm-4 px-2 form-success" *ngIf="stage === 3">
                    <div class="text-center form-success-logo">
                      <ion-icon color="success" class="py-2 success-verify-icon" name="checkmark-circle-outline"></ion-icon>
                    </div>
                    <p class="text-center text-light success-verify-message">Password updated successfully!<br>Please log in to continue.</p>
                    <div class="px-sm-4 px-2 ">
                      <ion-button class="mb-2 border-radius-20px" expand="block" share="round" color="secondary" routerLink="/login">
                        Log in
                      </ion-button>
                    </div>
                  </div>

                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>
